import { useState, useEffect } from "react";

const MOBILE_BREAKPOINT = 1024; // matches lg breakpoint in tailwind.config.js

/**
 * Returns true when viewport width is below the mobile breakpoint (1024px).
 * Listens for resize events and updates reactively.
 *
 * @param {number} [breakpoint=1024] - optional custom breakpoint
 * @returns {boolean}
 */
export const useIsMobile = (breakpoint = MOBILE_BREAKPOINT) => {
  const [isMobile, setIsMobile] = useState(
    typeof window !== "undefined" ? window.innerWidth < breakpoint : false,
  );

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < breakpoint);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [breakpoint]);

  return isMobile;
};
